import * as apiLib from './api';

export const list = async payload => {
  try {
    const data = {
      placeId: payload.placeId,
      limit: 100,
      LastEvaluatedKey: null,
    };

    const result = await apiLib.fetchArchiveApi('/gallery/list', data);
    if (result.resultFlag) {
      return result.galleryList;
    } else {
      throw Object.assign(new Error('group error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};

export const remove = async ({ jampicId }) => {
  try {
    const data = {
      jampicId: jampicId,
    };

    const result = await apiLib.fetchArchiveApi('/gallery/remove', data);
    if (result.resultFlag) {
      return true;
    } else {
      throw Object.assign(new Error('group error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};
